<template>
  <div class="tabbar">
    <div
      :class="['tabbar-item', { 'tabbar-active': active === index + 1 }]"
      v-for="(item, index) in list"
      :key="item.name"
      @click="goUrl(item.path)"
    >
      <img :src="active === index + 1 ? item.urlActive : item.url" />
      <div class="name">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      active: {
        type: Number,
        required: true,
      },
    },
  },
  data() {
    return {
      list: [
        {
          name: "首页",
          url: require("@/assets/mobile/image/common/home.png"),
          urlActive: require("@/assets/mobile/image/common/home-active.png"),
          path: "/mobile/home",
        },
        {
          name: "任务",
          url: require("@/assets/mobile/image/common/task.png"),
          urlActive: require("@/assets/mobile/image/common/task-active.png"),
          path: "/mobile/task",
        },
        {
          name: "兑换",
          url: require("@/assets/mobile/image/common/exchange.png"),
          urlActive: require("@/assets/mobile/image/common/exchange-active.png"),
          path: "/mobile/exchange",
        },
        {
          name: "我的",
          url: require("@/assets/mobile/image/common/my.png"),
          urlActive: require("@/assets/mobile/image/common/my-active.png"),
          path: "/mobile/my",
        },
      ],
    };
  },
  methods: {
    goUrl(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.tabbar {
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: 0;
  background: #ffffff;
  box-shadow: 0px -10px 10px 1px rgba(0, 0, 0, 0.02);
  display: flex;
  justify-content: space-between;
  padding: 0 41px;
  box-sizing: border-box;
  align-items: center;
  z-index: 99999999999;
  .tabbar-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 27px;
      height: 26px;
    }
    .name {
      font-size: 10px;
      color: #232323;
    }
  }
  .tabbar-active {
    .name {
      font-size: 10px;
      color: #8846FF;
      font-weight: bolder;
    }
  }
}
</style>